import { createFailure, createRequest, createSuccess } from 'ducks/helpers';
import constants from './constants';
import { createAction } from 'redux-actions';

export const pdfReportsRequest = createRequest(constants.pdfReports);
export const pdfReportsSuccess = createSuccess(constants.pdfReports);
export const pdfReportsFailure = createFailure(constants.pdfReports);

export const requestPDFReports = pdfReportsRequest;

export const pdfEntityReportsRequest = createRequest(constants.pdfEntityReports);
export const pdfEntityReportsSuccess = createSuccess(constants.pdfEntityReports);
export const pdfEntityReportsFailure = createFailure(constants.pdfEntityReports);

export const requestPDFEntityReports = pdfEntityReportsRequest;

export const setLoading = createAction(constants.setLoading);
